/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Edit_TitleInputs */



/**
* | output |
* | --- |
* | "Edit share" |
*
* @param {Team_Share_Edit_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_edit_title = /** @type {((inputs?: Team_Share_Edit_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Edit_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "de") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "it") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "es") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Edit share")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Edit share")
	return /** @type {LocalizedString} */ ("Edit share")
});